import type { MaterialLineItemOption } from "../types";
import type { MaterialRowItem } from "./materialLineItems";

export function buildCategoryEditKeys(
    materialsByGroup: Record<string, MaterialRowItem[]>,
) {
    const editKeyByCategory: Record<string, string> = {};
    const optionsByEditKey: Record<string, MaterialLineItemOption[]> = {};

    for (const rows of Object.values(materialsByGroup)) {
        for (const row of rows) {
            if (row.mode !== "single") continue;
            editKeyByCategory[row.category] = row.id;
            optionsByEditKey[row.id] = row.availableProducts;
        }
    }

    return { editKeyByCategory, optionsByEditKey };
}

export function resolveProductIdInOptions(
    manufacturerProductId: string,
    options: MaterialLineItemOption[],
): string | null {
    if (options.some((p) => p.ProductId === manufacturerProductId)) {
        return manufacturerProductId;
    }

    const prefix = `${manufacturerProductId}-`;
    return options.find((p) => p.ProductId.startsWith(prefix))?.ProductId ?? null;
}
